import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrderValue } from '@/hooks/tab';
import { useCurrentOrderItem } from '@/hooks/reference';
import { Heading } from '@/components/atoms/Section';
import Order from '@/components/organisms/order/Order';
import { ItemStandalone } from '@/components/organisms/section/Item';
import styles from './Common.module.scss';

const View: React.FC = () => {
  const { t } = useTranslation();
  const [inputValue] = useOrderValue();
  const [currentItem] = useCurrentOrderItem();
  const [item, setItem] = useState(currentItem);
  const id = Number(item);

  useEffect(() => {
    if (currentItem !== '' && currentItem !== item) {
      setItem(currentItem);
    }
  }, [currentItem]);

  if (currentItem) {
    return (
      <div className={styles.wrapperItem}>
        <ItemStandalone id={id} />
      </div>
    );
  }

  return (
    <>
      <div
        className={styles.container}
        data-cy={`PageContent-order__${id}`}
      >
        <div className={styles.headingContainer}>
          <div className={styles.headingOrder}>
            <Heading label={`${t('sidebar.order')} #${inputValue}`} />
          </div>
        </div>
        <div
          className={styles.sectionWrapper}
          data-cy={`PageContent-order__${id}_content`}
        >
          <div className={styles.wrapper}>
            <Order id={Number(inputValue)} />
          </div>
        </div>
      </div>
    </>
  );
};

export default View;
